import React, { useMemo } from 'react';
import { useGetGreatestListRaw } from 'utils/file-reader';
import { GreatestGames } from './components/GreatestGames';
import { ParseListsFromTextFile } from './utils/file-parsers';


function App() {
  const rawGreatestLists = useGetGreatestListRaw();

  const parsedGreatestLists = useMemo(() => {
    return ParseListsFromTextFile(rawGreatestLists);
  }, [rawGreatestLists]);

  return (
    <div style={{ display: 'flex' }}>
      <div>
        <GreatestGames data={parsedGreatestLists[0]} />
      </div>
    </div>
  )


}

export default App;
